import { UIHeading4, Body2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatCompanionTitle.css';

interface IChatCompanionTitleProps {
  primaryText: string;
  secondaryText?: string | null;
  handleClickName?: VoidFunction;
  userCardButtonNode?: React.ReactNode;
  dataTestId?: string;
}

export const ChatCompanionTitle: React.FC<IChatCompanionTitleProps> = ({
  primaryText,
  secondaryText,
  handleClickName,
  userCardButtonNode,
  dataTestId,
}) => {
  return (
    <div className={styles['title']} data-testid={dataTestId}>
      <UIHeading4 onClick={handleClickName}>{primaryText}</UIHeading4>

      {secondaryText && <Body2 color="text-secondary-default">{secondaryText}</Body2>}

      {userCardButtonNode}
    </div>
  );
};
